module.exports = __webpack_public_path__ + "img/New PACI Flow - Enable Authentication - 5.3d808e1b.png";